import { JSX, memo } from "react";
import { Stack, Tooltip, IconButton } from "@mui/material";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import StrikethroughSIcon from "@mui/icons-material/StrikethroughS";
import LinkIcon from "@mui/icons-material/Link";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import type { Editor } from "@tiptap/react";

type FormatType =
  | "bold"
  | "italic"
  | "underline"
  | "strike"
  | "link"
  | "bulletList"
  | "orderedList";

interface EditorToolbarProps {
  editor: Editor | null;
  buttons: FormatType[];
  onToggle: (format: FormatType) => void;
}

const EditorToolbar = memo(({ editor, buttons, onToggle }: EditorToolbarProps) => {
  if (!editor) return null;

  const formatIcons: Record<FormatType, JSX.Element> = {
    bold: <FormatBoldIcon fontSize="small" />,
    italic: <FormatItalicIcon fontSize="small" />,
    underline: <FormatUnderlinedIcon fontSize="small" />,
    strike: <StrikethroughSIcon fontSize="small" />,
    link: <LinkIcon fontSize="small" />,
    bulletList: <FormatListBulletedIcon fontSize="small" />,
    orderedList: <FormatListNumberedIcon fontSize="small" />,
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        mb: 1,
        backgroundColor: "grey.100",
        width: "fit-content",
        borderRadius: 1,
      }}
    >
      {buttons.map((format) => (
        <Tooltip key={format} title={format.replace(/([A-Z])/g, " $1")}>
          <IconButton
            size="small"
            onClick={() => onToggle(format)}
            color={editor.isActive(format) ? "primary" : "default"}
          >
            {formatIcons[format]}
          </IconButton>
        </Tooltip>
      ))}
    </Stack>
  );
});

export default EditorToolbar;
